import React, { useEffect, useRef } from 'react';

const MouseTrail = () => {
  const canvasRef = useRef(null);
  const mouseX = useRef(0);
  const mouseY = useRef(0);
  const trails = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;

    

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();

    const updateMousePosition = (event) => {
      mouseX.current = event.clientX;
      mouseY.current = event.clientY; // effet visuel décalé
    };

    const draw = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const currentX = mouseX.current;
      const currentY = mouseY.current;

      // Ajoute un nouveau point uniquement si différent du dernier
      const last = trails.current[trails.current.length - 1];
      if (!last || last.x !== currentX || last.y !== currentY) {
        trails.current.push({ x: currentX, y: currentY, life: 0 });
      }

      // Vieillissement
      trails.current.forEach((p) => {
        p.life += 1;
      });

      // Supprimer les anciens points (vie > 50)
      trails.current = trails.current.filter((p) => p.life <= 50);

      // Dessiner les lignes
      trails.current.forEach((trail, i) => {
        const dx = currentX - trail.x;
        const dy = currentY - trail.y;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist > 2) {
          const opacity = 1 - trail.life / 50;
          ctx.beginPath();
          ctx.moveTo(trail.x, trail.y);
          ctx.lineTo(currentX, currentY);
          ctx.strokeStyle = `rgba(255, 255, 255, ${opacity})`;
          ctx.stroke();
        }
      });

      animationFrameId = requestAnimationFrame(draw);
    };

    canvas.addEventListener('mousemove', updateMousePosition);
    draw();

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', resizeCanvas);
      canvas.removeEventListener('mousemove', updateMousePosition);
    };
  }, []);

  return (
<canvas
  ref={canvasRef}
  width={window.innerWidth} // attribut HTML (pas style)
  height={window.innerHeight} // attribut HTML (pas style)
  style={{
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 0,
  }}
/>
  );
};

export default MouseTrail;
